import { TextField } from '@mui/material';
import styled from 'styled-components';
import { BodyCopyStyle, LabelStyle } from '../../../utils/styleConstants';

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    height: 56px;
    border-radius: 8px;

    fieldset {
      border-color: #e0e0e0;
      border-width: 1px;
    }

    &:hover fieldset {
      border-color: #e0e0e0;
    }

    &.Mui-focused fieldset {
      border-color: #2196f3;
      border-width: 1px;
    }
  }

  .MuiInputLabel-root {
    font-family: ${LabelStyle.fontFamily} !important;
    font-size: ${LabelStyle.fontSize} !important;
    font-weight: ${LabelStyle.fontWeight} !important;
    line-height: ${LabelStyle.lineHeight} !important;
    letter-spacing: ${LabelStyle.letterSpacing} !important;
    color: ${LabelStyle.color} !important;
    text-transform: ${LabelStyle.textTransform} !important;

    &.Mui-focused {
      color: #2196f3 !important;
    }

    &.MuiInputLabel-shrink {
      top: 7px;
      font-size: 11px;
      color: #666 !important;
    }
  }

  .MuiInputBase-input {
    font-family: ${BodyCopyStyle.fontFamily} !important;
    font-size: ${BodyCopyStyle.fontSize} !important;
    font-weight: ${BodyCopyStyle.fontWeight} !important;
    line-height: ${BodyCopyStyle.lineHeight} !important;
    letter-spacing: ${BodyCopyStyle.letterSpacing} !important;
    color: ${BodyCopyStyle.color} !important;
    padding: 16px 12px 8px 12px;
    height: auto;
  }

  .MuiFormHelperText-root {
    font-family: ${BodyCopyStyle.fontFamily} !important;
    font-size: 12px !important;
    color: #666 !important;
  }

  /* Mobile responsive styles */
  @media (max-width: 768px) {
    .MuiOutlinedInput-root {
      height: 52px;
    }

    .MuiInputLabel-root {
      top: 6px;

      &.MuiInputLabel-shrink {
        top: 9px;
        font-size: 11px;
      }
    }

    .MuiInputBase-input {
      padding: 14px 12px 6px 12px;
    }
  }
`;
